import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppMaterialModule } from 'src/app/app-material/app-material.module';
import { SidenavComponent } from './sidenav.component';

@NgModule({
    declarations: [SidenavComponent],
    imports: [
      CommonModule,
      AppMaterialModule,
      HttpClientModule,
      TranslateModule,
      RouterModule,
      DropDownListModule
    ]
  })
  export class SideNavModule { }